import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import type {
  ClientQuestionnaireModel,
} from '../../../../../../../common/dist/angular/models/client-questionnaire.model';
import { QuestionnaireUtils } from '../../../../../modules/src/lib/questionnaires/utils/questionnaire.utils';


@Component({
  selector: 'app-dashboard-questionnaire',
  templateUrl: './dashboard-questionnaire.component.html',
  styleUrls: ['./dashboard-questionnaire.component.scss'],
  standalone: false,
})
export class DashboardQuestionnaireComponent implements OnInit {

  @Input()
  questionnaire: ClientQuestionnaireModel;

  @Input()
  showShowAccessQuestionnaireButton: boolean;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }


  getStatusText(): string {
    return QuestionnaireUtils.getStatusText(this.questionnaire.status);
  }

  getName() {
    return QuestionnaireUtils.getName(this.questionnaire.keyname);
  }
}
